import React from "react";
import classes from "../FormSizeOfPlan.module.scss";
import cx from "classnames";
import dompurify from "dompurify";

import avgSavingsIcon from "../../../assets/images/avgSavings.jpg";
import concessionIcon from "../../../assets/images/concession.png";
import seatIcon from "../../../assets/images/seat.png";
import calendar from "../../../assets/images/calendar.png";
import guaranteeIcon from "../../../assets/images/guarantee.png";
import bobblehead from "../../../assets/images/bobblehead.png";
import chevRight from "../../../assets/images/chevRight.png";

const planContent = (props) => {
  const sanitizer = dompurify.sanitize;
  let firstPlan = props.styleOfPlanSelected[0];

  let planBody = props.styleOfPlanSelected.map((res, index) => {
    // TODO uncomment to hide 20 pick em
    // if (res.planChoice === "twentyFlexible") return null;
    return (
      <div
        key={index}
        className={cx(
          classes.row,
          props.sizeOfPlanSelected === res.planChoice
            ? classes.planActive
            : classes.planDeactive,
          res.soldOut ? classes.planSoldOut : ""
        )}
        onClick={() =>
          res.soldOut ? null : props.onClickSizeOfPlanChoice(res.planChoice)
        }
      >
        <div className={cx(classes.col, classes.planChoices)}>
          <span
            className={classes.numOfGames}
            dangerouslySetInnerHTML={{ __html: sanitizer(res.numOfGames) }}
          />
          <span className={classes.numOfGamesTitle}>
            {props.planType !== "premier"
              ? props.styleOfPlanSelectedName === "flexible"
                ? "TICKETS"
                : "Games"
              : ""}
          </span>
          {/* <span className={classes.numOfGamesNote}>{res.gameFrequency}</span> */}
          <span className={cx(classes.numOfGamesNote, classes.red)}>
            Plans start at {res.priceRange}
          </span>
          <span className={classes.blueButton}>
            <img src={chevRight} alt="Plan Choice Icon" />
          </span>
        </div>
        {res.concession && (
          <div className={cx(classes.col, classes.num, classes.values)}>
            {res.concession}
          </div>
        )}
        {res.avgSavings && (
          <div className={cx(classes.col, classes.num, classes.values)}>
            {res.avgSavings}
          </div>
        )}
        {res.numOfSeats && (
          <div className={cx(classes.col, classes.num, classes.values)}>
            {res.numOfSeats}
          </div>
        )}
        {res.guaranteedBobbleheads && (
          <div className={cx(classes.col, classes.num, classes.values)}>
            {res.guaranteedBobbleheads}
          </div>
        )}
        {res.openingDayAccess && (
          <div className={cx(classes.col, classes.num, classes.values)}>
            {res.openingDayAccess}
          </div>
        )}
        {res.postSeason && (
          <div className={cx(classes.col, classes.num, classes.values)}>
            {res.postSeason}
          </div>
        )}
        {res.exclusiveEventsWithPlayers && (
          <div className={cx(classes.col, classes.num, classes.values)}>
            {res.exclusiveEventsWithPlayers}
          </div>
        )}
      </div>
    );
  });
  return (
    <div className={classes.FormSizeOfPlan}>
      <div className={cx(classes.header, classes.row)}>
        <div className={cx(classes.col, classes.emptyCol)}></div>
        {firstPlan.concession && (
          <div className={classes.col}>
            <span className={classes.headerIcon}>
              <img
                src={concessionIcon}
                style={{ maxWidth: "26px" }}
                alt="Avg Savings Icon"
              />
            </span>
            <span>
              Savings Off
              <br />
              Concessions & Merchandise
            </span>
          </div>
        )}
        {firstPlan.avgSavings && (
          <div className={classes.col}>
            <span className={classes.headerIcon}>
              <img
                src={avgSavingsIcon}
                style={{ maxWidth: "33px" }}
                alt="Avg Savings Icon"
              />
            </span>
            <span>
              Average Savings off
              <br />
              Single-Game Ticket Prices
            </span>
          </div>
        )}
        {firstPlan.numOfSeats && (
          <div className={classes.col}>
            <span className={classes.headerIcon}>
              <img
                src={calendar}
                style={{ maxWidth: "34px" }}
                alt="Avg Savings Icon"
              />
            </span>
            <span>
              # of Ticket Exchanges
              <br />
              for Games You Can't Make
            </span>
          </div>
        )}
        {firstPlan.guaranteedBobbleheads && (
          <div className={classes.col}>
            <span className={classes.headerIcon}>
              <img
                src={bobblehead}
                style={{ maxWidth: "34px" }}
                alt="Avg Savings Icon"
              />
            </span>
            <span>
              Guaranteed
              <br />
              Bobbleheads
            </span>
          </div>
        )}
        {firstPlan.openingDayAccess && (
          <div className={classes.col}>
            <span className={classes.headerIcon}>
              <img
                src={seatIcon}
                style={{ maxWidth: "34px" }}
                alt="Avg Savings Icon"
              />
            </span>
            <span>
              Opening Day
              <br />
              Access
            </span>
          </div>
        )}
        {firstPlan.postSeason && (
          <div className={classes.col}>
            <span className={classes.headerIcon}>
              <img
                src={guaranteeIcon}
                style={{ maxWidth: "34px" }}
                alt="Avg Savings Icon"
              />
            </span>
            <span>
              Postseason
              <br />
              Access
            </span>
          </div>
        )}
        {firstPlan.exclusiveEventsWithPlayers && (
          <div className={classes.col}>
            <span className={classes.headerIcon}>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAAA+CAMAAACfiDARAAAAb1BMVEUAAAAACUgACEgACEgACUgACkcAC0cACUsACEcACEcACEcACUcAHVMACUcACEgAFFUACEgACEcACEcADVAAC0gACUgACUcADUsACUgACkoACEcACEcACkgACUkACUcACEgACUgACUkACUgADUoACEeSp9tKAAAAJHRSTlMAsXV/ik9EOrn45ckIo18M89mbEyxo7ySqGdGUSj/qwoU1WB9qqz+oAAAC1UlEQVRo3uzU226rMBSE4QGSFNsQzgQCzXHe/xl3WhUMLQhY1b7rdx2Nftk4GAvyE34l+s8DWajIeBdAwA6UN4jV1ceAhzl3zU/JEzJvF34615B5L/nJZJgUJPziQyTS/OJAJOsHKkzy2HtA4sbeHhINewdMMeyFkEjYSyGh2Wsw5cLeFRIxez4kaDmYch7+QEL/9houS9eQsudCImSvgITD3hFTcsUvZQaJOzuXCBLv7OiZAVf+HscD6gCZWzfwjhm739xS2wBpd0sCWRP238pj6RT2CLWLbYJXnQuv+1ML/XzrJWuy6A7pbTnRIc0TG5zOJD2b6FO5278Rd1si4wKrFTG/J5L+CWs9fQoSX8wdq+RXciKRyguwiqsoS3ypTliU7RQnE190gWWHMylJ7IQLJxl5MTmX+JIU0cIzuZKyRMscI8zJm5hWMUrsxE2OOcHR0NL3DYn7CweUc8zw08k1HCgfsIk7DiW3+1Rfm5YccDJsSESWckSZtMgH63mRJhzxawwSsdcc0Y7X1ujVrefHHIqPwKZE4G74Q5kYv3J8c+F3+gGMEhG4XYKl9PnqVP41UfwurLE5EWgNV1JehHHih3qnuJJ5NUkSgdbnCvGuBiYSgex2WRW4B6SJQN6UC/vay4CJRPtkF/gHQJRo7SvFOapqYdnE8cM/c1bi1oA40Qreb2ZqvtlHwHyidSpCzR+U755gCROtKD/eHJNoRaoy8VP3kMGaTbSerZtez7okGWtT7Y45LEGikE1c4y/xL/Ffe3auAiAMRFFU4x7iFhEX3PX/v9HCIohMSNL6ppbLwekmIIIIIogggggiiCCCCCKIIIII4i+IZ8CfD8a2dOp3G1fvIE6BcNEExJFearJ8ts2LYr3UVPaB8h2Q6k9S92IenBb9XX4CNbMJJLLSXHCbdiSu0IUwyjeMChxmgYHVRCB6Ntz75OSTyYZ1gdhgw7qAnL0brxMpGay5wkAAAAAASUVORK5CYII="
                style={{ maxWidth: "52px" }}
                alt="Avg Savings Icon"
              />
            </span>
            <span>
              Exclusive Events
              <br />
              with Nationals Players
            </span>
          </div>
        )}
      </div>
      {planBody}
    </div>
  );
};

export default planContent;

// avgSavings: plan.sizeAvgSavings,
// concession: plan.sizeConcession,
// numOfSeats: plan.sizeNumOfSeats,
// postSeason: plan.sizePostSeason,
// guaranteedBobbleheads: plan.sizeGuaranteedBobbleheads,
// openingDayAccess: plan.sizeOpeningDayAccess,
// exclusiveEventsWithPlayers: plan.sizeExclusiveEventsWithPlayers,
